import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import StandardError from 'components/common/standard_error'
import { UNDER_REVIEW_ERROR } from 'shared/shared_consts'

const i18n = getI18n('components/edit_glimpse/edit_error')

class EditError extends React.Component {
  static propTypes = {
    fieldNames: PropTypes.arrayOf(PropTypes.string),
    onTryAgain: PropTypes.func,
    error: PropTypes.object,
  }

  render() {
    if (this.props.error.error === UNDER_REVIEW_ERROR) {
      return (
        <StandardError
          iconType="error"
          title={i18n('review_title')}
          subtitle={i18n('review_subtitle')}
          backButton={true}
        />
      )
    }
    return (
      <StandardError
        iconType="warning"
        title={i18n('title')}
        subtitle={i18n('subtitle')}
        onTryAgain={this.props.onTryAgain}
        showButton={true}
      />
    )
  }
}

export default EditError
